function newClassGradeText(gradeData) {
  switch (gradeData) {
    case 'first':
    case 'seventh':
    case 'tenth':
      return '1학년';
    case 'second':
    case 'eighth':
    case 'eleventh':
      return '2학년';
    case 'third':
    case 'ninth':
    case 'twelfth':
      return '3학년';
    case 'fourth':
      return '4학년';
    case 'fifth':
      return '5학년';
    case 'sixth':
      return '6학년;';
    default:
      return '';
  }
}

export default newClassGradeText;



// WEBPACK FOOTER //
// ./src/filters/newClassGradeText.js